// Automatically generated from TW.Saga.Shared.MetadataLib, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @19.06.2017 18:53:46
import { ListProcedureStatus_abstract } from './../abstract/SagaStateLib/ListProcedureStatus_abstract';
export class ListProcedureStatus extends ListProcedureStatus_abstract {}
